/**
 * 10-letter words for RSTLNE game
 * Exact words from original project
 */

const words10: string[] = [
  "WILDERNESS", "QUARANTINE", "RETIREMENT", "FIGURATIVE", "OCCASIONAL", "BANKRUPTCY", "REPUTATION", "LABORATORY", "TREMENDOUS", "WATERMELON",
  "EXPERIENCE", "BACKGROUND", "FRIENDSHIP", "TECHNOLOGY", "VOCABULARY", "PSYCHEDELIC", "DEPLOYMENT", "QUARRELSOME", "AERONAUTIC", "ENORMOUS",
  "ENGAGEMENT", "ULTIMATELY", "MANAGEMENT", "IMPRESSION", "MECHANICAL", "ILLUMINATE", "LITERATURE", "JUBILATION", "NAVIGATION", "SPECTACULAR",
  "APPRECIATE", "CHALLENGER", "SOLIDARITY", "PRODUCTIVE", "WANDERLUST", "GREGARIOUS", "PERCEPTION", "YELLOWTAIL", "WORKAROUND", "CAPABILITY",
  "ENTHUSIASM", "ENTERPRISE", "GRATEFULLY", "BINOCULAR", "SILHOUETTE", "CAMOUFLAGE", "PERPLEXITY", "OBLIGATION", "NATURALIST", "MEMORANDUM",
  "UNDERSTAND", "DERIVATIVE", "LEADERSHIP", "FOUNDATION", "HELICOPTER", "COLLECTION", "REVOLUTION", "DEMOCRATIC", "JUGGERNAUT", "GROUNDWORK",
  "PSYCHOLOGY", "LONGEVITY", "CALAMITOUS", "HABITATION", "UNDERNEATH", "EXPEDITION", "ATMOSPHERE", "DECISIVELY", "IMPEDIMENT", "MONITORING",
  "IMPOSSIBLE", "VULNERABLE", "SITUATION", "HABITUALLY", "NEUROLOGY", "VALIDATION", "RHINOCEROS", "ABSOLUTELY", "REMARKABLE", "BLACKBERRY",
  "ADVENTURER", "HARASSMENT", "JOURNALISM", "FRACTIONAL", "NEUTRALIZE", "TYPEWRITER", "STRUCTURED", "OCCUPATION", "GENERATION", "VISIBILITY",
  "CHRONOLOGY", "NETWORKING", "MAYONNAISE", "BASKETBALL", "COMMENTARY", "DICTIONARY", "EVERYTHING", "INNOVATION",
  "PHILOSOPHY", "STRAWBERRY", "TOURNAMENT", "XENOPHOBIA", "ACCOMPLISH", "COMPLEMENT", "ELEMENTARY", "ASTRONOMER",
  "PLAYGROUND", "WATERPROOF", "TELEVISION", "REASONABLE", "EARTHQUAKE", "PHOTOGRAPH", "COMPATIBLE", "MANUSCRIPT",
  "INCREDIBLE", "UNDERWATER", "THOUGHTFUL", "AUTOMOBILE", "EVERYWHERE", "GREENHOUSE", "STRENGTHEN", "TABLESPOON",
  "MOTORCYCLE", "THEMSELVES", "LIGHTHOUSE", "THROUGHOUT", "TOOTHBRUSH", "WHEELCHAIR", "CHESSBOARD", "POWERHOUSE",
  "TABLECLOTH", "BORDERLAND", "CROSSROADS", "STOREHOUSE", "SKATEBOARD", "MOTHERLAND", "COURTHOUSE", "SCHOOLYARD",
  "PERMISSION", "POLITICIAN", "FINGERNAIL", "DEPARTMENT", "INSTRUMENT", "RESTAURANT", "WATERSLIDE",
  // New additions - September 19, 2025
  "CALCULATOR", "BLACKBOARD", "SMOOTHNESS", "PAINTBRUSH", "DISHWASHER",
  "GRAPEFRUIT", "MICROPHONE", "NEWSLETTER", "CLOCKTOWER", "VOLLEYBALL",
  "ICEBREAKER", "UNDERWORLD", "TOOTHPASTE", "HEADPHONES", "WATERCOLOR",
  "FLASHLIGHT", "PILLOWCASE", "TRAMPOLINE", "BACKPACKER", "CHALKBOARD",
  "HEARTBREAK", "ILLUSTRATE", "JOURNALIST", "KICKBOXING", "MASTERWORK",
  "NIGHTSHIFT", "OVERTHROWN", "BRIGHTNESS", "REASONABLY", "THREADBARE",
  "BATTLESHIP", "DOORKEEPER", "HOUSEPLANT", "SPACECRAFT", "WONDERLAND"
];

export default words10;
